import { connect } from "react-redux";

import { getAccountServicePlanList } from "actions/self_allocation_restrictions";
import SelfAllocationRestrictions from "./SelfAllocationRestrictions";


const mapState = ({ auth, self_allocation_restrictions, roles }) => ({
    data: self_allocation_restrictions.list,
    service: auth.service,
    loading: self_allocation_restrictions.loading,
    roleList: roles.role_list
});

export default connect(mapState, {
    getAccountServicePlanList
})(SelfAllocationRestrictions);